<template>
  <div class="app-page-header text-center py-5">
    <h1 class="app-page-title">{{ title }}</h1>
    <span v-if="admin" class="badge badge-pill header__badge d-inline-flex"
      >Администрирование</span
    >
  </div>



  <!-- <div class="custom-header d-flex flex-column align-items-center">
      <div class="header__text d-flex justify-content-center">
        
      </div>     
      
    </div> -->
  <!--
<div id="page_title" class="header-h1 header-h1-left" style="margin: 0; padding-top: 20px; padding-bottom: 10px; padding-left: 20px;">
  <h1>{{ title }}</h1>
  <p v-if="admin" class="badge rounded-pill bg-danger text-light">Администрирование</p>
</div>
-->
</template>


<script>
export default {
  data() {
    return {};
  },
  props: {
    title: String,
    admin: Boolean,
  },
  mounted() {},
};
</script>

<style scoped>






/* 
    PageTitle
 */

/*
.app-page-header {

}
*/

.app-page-title {
    font-size: 1.8rem !important;
    color    : var(--color-blue-gray-3);
}




.custom-header {
  /* background-color:#F0F4F8; */
  padding: 50px 0;
  color: #243b53;
}

.header__text h1 {
  font-size: 60px;
}

.header__badge {
  background-color: #d9e2ec;
  color: #486581;
}

/*

    #page_title {
        background-color: #dbefff;
    }


  .header-h1 h1 {
    position: relative;
    padding-bottom: .5rem;
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    color: black;
  }
  .header-h1 h1::before {
    content: "";
    position: absolute;
    border-bottom: 2px solid black;
    bottom: .25rem;
    left: 50%;
    width: 30%;
    transform: translateX(-50%);
  }
  .header-h1 h1::after {
    content: "";
    position: absolute;
    border-bottom: 2px solid black;
    bottom: 0;
    left: 50%;
    width: 15%;
    transform: translateX(-50%);
  }
  .header-h1-left h1 {
    text-align: left;
  }
  .header-h1-left h1::before,
  .header-h1-left h1::after {
    left: 0;
    transform: translateX(0);
  }
  .header-h1-right h1 {
    text-align: right;
  }
  .header-h1-right h1::before,
  .header-h1-right h1::after {
    left: unset;
    right: 0;
    transform: translateX(0);
  }
*/
</style>